import { render } from "./ProcoreUser.vue?vue&type=template&id=32e9a16c"
import script from "./ProcoreUser.vue?vue&type=script&lang=js"
export * from "./ProcoreUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__